import Animation from './animation'

/*
 * This animation is used when a `line` type serie is being removed.
 */
class ExitingAnimation extends Animation {

  match (serie) {
    return this.seriesChanged && // Series changed
           this.exitingSeries.selection().data().indexOf(serie) !== -1 // this serie is part of the exiting selection
  }

  animate (serie, entering, selection, merged, exiting) {
    // exiting is a transition, grab its selection and then walk the line
    let initialOffset = 0
    this._walkLine(exiting.selection().selectAll(`.${serie.type}-group`), merged, this._shrinkPath, initialOffset, {
      x: this.previous.scalers.x.center,
      y: this.previous.yScale
    })
  }

}

export default ExitingAnimation
